// @flow weak
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { PanelContainer } from '@sketchpixy/rubix/lib/index'
import { Panel, PanelBody } from '@sketchpixy/rubix/lib/Panel'
import AdminProfile from '../pages/AdminProfile'
import User from '../pages/User'
import {APP_ADMIN_ROLE, ADMIN_ROLE} from '../utils'

class Profile extends Component {

  render () {
    const {userInfo, history} = this.props

    return (

      <PanelContainer className='inbox' collapseBottom>
        <Panel>
          <PanelBody
            style={{paddingTop: 0}}>
            {
              userInfo && userInfo.role === APP_ADMIN_ROLE ? <User history={history} />
              : userInfo && userInfo.role === ADMIN_ROLE ? userInfo && userInfo.id ? <AdminProfile profile entityId={userInfo.id} editable={false}/>
                : null
              : null
            }
          </PanelBody>
        </Panel>
      </PanelContainer>
    )
  }
}

const
  mapStateToProps = state => ({
                                user: {
                                  me: {error = undefined, fetching = false, userInfo = {}}
                                }
                              }) => {
    return {userInfo, fetching, error}
  }

const
  mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Profile)
